import { render, staticRenderFns } from "./MsDropDownMenu.vue?vue&type=template&id=5b812116&scoped=true&lang=html"
import script from "./MsDropDownMenu.vue?vue&type=script&lang=js"
export * from "./MsDropDownMenu.vue?vue&type=script&lang=js"
import style0 from "./MsDropDownMenu.vue?vue&type=style&index=0&id=5b812116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b812116",
  null
  
)

export default component.exports